import React from 'react'
import { MdOutlineKeyboardCommandKey } from "react-icons/md";

const Tooltip = ({ text, letter, width, icon = true }) => {
    return (
        <div style={{ width: `${width}px` }} className='tooltip-container'>
            <div className='tooltip-content'>
                <span className='text-center'>{text}</span>
                {icon && 
                    <div className='flex items-center justify-center gap-3'>
                        <MdOutlineKeyboardCommandKey />
                        <span>{letter}</span>
                    </div>
                }                
            </div>
        </div>
    )
}

export default Tooltip